import React from 'react';
import {Row, Col} from 'react-bootstrap';
import Page from './Page';

import '../css/DentalHealth.css';
import Intro from '../assets/Dental Health/intro.jpg';
import Recognize from '../assets/Dental Health/recognize.png';
import Closeup from '../assets/Dental Health/Recognize1.png';
import Closeup2 from '../assets/Dental Health/Recognize2.png';

class DentalHealth extends Page{
    constructor(props) {
        super(props);
        this.goToHomePage = this.goToHomePage.bind(this);

    }

    componentDidMount() {
        document.title = "Dental Health | Vetradent™";
    }
    goToHomePage(){
        this.props.setPage("home")
    }

    render(){
        return(
            <div className="dental-health">
                <div style={{backgroundImage:"url("+Intro+")"}}  className = "chunk-routine">
                    <div className="breadcrumbs"><a aria-label="home page" onClick={this.goToHomePage} className="breadcrumb-home">Home</a><div className="breadcrumb-page"> &nbsp; Dental Health</div></div>

                    <Row>
                        <Col xs={12} sm={12} md={5} lg={4}>

                            <h1 className ="accent-headline">{this.contentParser("headline")}</h1>
                            <p className ="accent-text">{this.contentParser("headline-text")}</p>
                        </Col>
                    </Row>
                </div>
                <div style={{backgroundImage:"url("+Recognize+")"}}  className="chunk-recognize">
                    <Row>
                        <Col xs={12} sm={12} md={7}>
                            <h2>{this.contentParser("recognize-headline")}</h2>
                            <p>{this.contentParser("recognize-text")}</p>
                            <div className = "close-up" >
                                <img src = {Closeup} alt="Dogs Teeth" />
                            </div>
                            <div className="close-up" >
                                <img src = {Closeup2} alt="Closeup of Dogs Teeth" />
                            </div>

                        </Col>

                    </Row>
                </div>
                <div className="chunk-grey">
                    <h2 className="dechra-text">{this.contentParser("matters-headline")}</h2>
                    <p className="neutral-text">{this.contentParser("matters-text")}</p>
                    <h2 className="dechra-text">{this.contentParser("how-headline")}</h2>
                    <p className="neutral-text">{this.contentParser("how-text")}</p>

                </div>

            </div>

        )

    }



}

export default DentalHealth;


// WEBPACK FOOTER //
// ./src/components/DentalHealth.js